const translations = {
    cancel: 'Cancel',
    make: 'Controller Make',
    model: 'Controller Model',
    nickname: 'Nickname',
    nicknameMax: 'Nickname cannot exceed {{charMax}} characters',
    notProvided: 'Not provided',
    saving: 'Saving…',
    selectMake: 'Select a make',
    selectModel: 'Select a model',
    serialNumber: 'Serial Number',
    serialNumberMax: 'Serial number cannot exceed {{charMax}} characters'
};

export default translations;
